import arrow from '../svg/arrow.svg';
export const arrowStyles = {
  background: '#fff',
  borderRadius: '50%',
  backgroundImage: `url(${arrow})`,
  backgroundPosition: '50% 50%',
  backgroundSize: 20,
  backgroundRepeat: 'no-repeat',
};
